import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LocalStoreService } from './local-store.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGaurd  {

  constructor(
    private router: Router,
    private auth: AuthService,
    private store: LocalStoreService,
    private translate: TranslateService,
  ) { }

  canActivate() {
    if (!this.auth.isTokenExpired()) {
      var languages = this.store.getItem("languages");
      var translationsData = this.store.getItem("languageTexts");
      var defaultLanguage = this.store.getItem('defaultLanguage');

      this.translate.setTranslation(defaultLanguage, translationsData);
      this.translate.setDefaultLang(defaultLanguage);
      return true;
    } else {
      this.auth.signout();
    }
  }
}
